import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
/* import { createLogger } from 'redux.l'; */
import rootReducer from './reducers/root.reducer';

/* const loggerMiddleware = createLogger(); */

export const store = createStore(
  /*   window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), */
    rootReducer,
    applyMiddleware(
        thunkMiddleware,
       /*  loggerMiddleware */
    )
);